import {
    availableCastingJobTypes,
    availableEventSupportJobTypes,
    availableBarsRestaurantsJobTypes,
    availableMasterOfCeremoniesJobTypes
} from '@/helpers/availableJobTypeHelper'

export default {
    availableJobTypes() {
        return [
            ...availableCastingJobTypes,
            ...availableEventSupportJobTypes,
            ...availableBarsRestaurantsJobTypes,
            ...availableMasterOfCeremoniesJobTypes
        ]
    }
}
